/**
 * DevExtreme (esm/renovation/ui/pager/common/base_pager_props.js)
 * Version: 21.2.10
 * Build date: Fri Sep 02 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var BasePagerProps = {
    gridCompatibility: true,
    showInfo: false,
    displayMode: "adaptive",
    maxPagesCount: 10,
    pageCount: 10,
    visible: true,
    hasKnownLastPage: true,
    pagesNavigatorVisible: "auto",
    showPageSizes: true,
    get pageSizes() {
        return [5, 10]
    },
    showNavigationButtons: false,
    totalCount: 0
};
